var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeartO(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 9.85c3.688-3.336 4.667-4.557 4.667-5.978 0-1.136-.84-1.993-1.967-1.993-.627 0-1.278.31-1.687.805L6 3.907 4.987 2.684C4.578 2.19 3.927 1.88 3.3 1.88c-1.127 0-1.967.857-1.967 1.993 0 1.42.98 2.642 4.667 5.978zm0-8.063l.807-.714C7.37.708 8.036.5 8.7.5 10.56.5 12 1.971 12 3.872c0 2.33-2.04 4.23-5.16 7.05l-.371.379c-.26.265-.678.265-.938 0l-.371-.38C2.04 8.102 0 6.202 0 3.872 0 1.972 1.44.5 3.3.5c.664 0 1.329.208 1.893.573L6 1.787z",
    transform: "translate(-312 -906) translate(80 688) translate(232 218)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartO);
export default __webpack_public_path__ + "static/media/icon-heart-o.37c1d1da.svg";
export { ForwardRef as ReactComponent };